import icon__0_302ai_svg from '../../assets/Icons/ModelsDevProviders/302ai.svg'
import icon__1_abacus_svg from '../../assets/Icons/ModelsDevProviders/abacus.svg'
import icon__2_abliteration_ai_svg from '../../assets/Icons/ModelsDevProviders/abliteration-ai.svg'
import icon__3_aihubmix_svg from '../../assets/Icons/ModelsDevProviders/aihubmix.svg'
import icon__4_alibaba_svg from '../../assets/Icons/ModelsDevProviders/alibaba.svg'
import icon__5_alibaba_cn_svg from '../../assets/Icons/ModelsDevProviders/alibaba-cn.svg'
import icon__6_alibaba_coding_plan_svg from '../../assets/Icons/ModelsDevProviders/alibaba-coding-plan.svg'
import icon__7_alibaba_coding_plan_cn_svg from '../../assets/Icons/ModelsDevProviders/alibaba-coding-plan-cn.svg'
import icon__8_alibaba_token_plan_svg from '../../assets/Icons/ModelsDevProviders/alibaba-token-plan.svg'
import icon__9_amazon_bedrock_svg from '../../assets/Icons/ModelsDevProviders/amazon-bedrock.svg'
import icon__10_ambient_svg from '../../assets/Icons/ModelsDevProviders/ambient.svg'
import icon__11_anthropic_svg from '../../assets/Icons/ModelsDevProviders/anthropic.svg'
import icon__12_anyapi_svg from '../../assets/Icons/ModelsDevProviders/anyapi.svg'
import icon__13_atomic_chat_svg from '../../assets/Icons/ModelsDevProviders/atomic-chat.svg'
import icon__14_auriko_svg from '../../assets/Icons/ModelsDevProviders/auriko.svg'
import icon__15_azure_svg from '../../assets/Icons/ModelsDevProviders/azure.svg'
import icon__16_azure_cognitive_services_svg from '../../assets/Icons/ModelsDevProviders/azure-cognitive-services.svg'
import icon__17_bailing_svg from '../../assets/Icons/ModelsDevProviders/bailing.svg'
import icon__18_baseten_svg from '../../assets/Icons/ModelsDevProviders/baseten.svg'
import icon__19_berget_svg from '../../assets/Icons/ModelsDevProviders/berget.svg'
import icon__20_cerebras_svg from '../../assets/Icons/ModelsDevProviders/cerebras.svg'
import icon__21_claudinio_svg from '../../assets/Icons/ModelsDevProviders/claudinio.svg'
import icon__22_cloudferro_sherlock_svg from '../../assets/Icons/ModelsDevProviders/cloudferro-sherlock.svg'
import icon__23_cloudflare_ai_gateway_svg from '../../assets/Icons/ModelsDevProviders/cloudflare-ai-gateway.svg'
import icon__24_cloudflare_workers_ai_svg from '../../assets/Icons/ModelsDevProviders/cloudflare-workers-ai.svg'
import icon__25_cohere_svg from '../../assets/Icons/ModelsDevProviders/cohere.svg'
import icon__26_crossmodel_svg from '../../assets/Icons/ModelsDevProviders/crossmodel.svg'
import icon__27_deepinfra_svg from '../../assets/Icons/ModelsDevProviders/deepinfra.svg'
import icon__28_deepseek_svg from '../../assets/Icons/ModelsDevProviders/deepseek.svg'
import icon__29_digitalocean_svg from '../../assets/Icons/ModelsDevProviders/digitalocean.svg'
import icon__30_dinference_svg from '../../assets/Icons/ModelsDevProviders/dinference.svg'
import icon__31_drun_svg from '../../assets/Icons/ModelsDevProviders/drun.svg'
import icon__32_empiriolabs_svg from '../../assets/Icons/ModelsDevProviders/empiriolabs.svg'
import icon__33_evroc_svg from '../../assets/Icons/ModelsDevProviders/evroc.svg'
import icon__34_fastrouter_svg from '../../assets/Icons/ModelsDevProviders/fastrouter.svg'
import icon__35_fireworks_ai_svg from '../../assets/Icons/ModelsDevProviders/fireworks-ai.svg'
import icon__36_freemodel_svg from '../../assets/Icons/ModelsDevProviders/freemodel.svg'
import icon__37_friendli_svg from '../../assets/Icons/ModelsDevProviders/friendli.svg'
import icon__38_frogbot_svg from '../../assets/Icons/ModelsDevProviders/frogbot.svg'
import icon__39_github_copilot_svg from '../../assets/Icons/ModelsDevProviders/github-copilot.svg'
import icon__40_github_models_svg from '../../assets/Icons/ModelsDevProviders/github-models.svg'
import icon__41_gitlab_svg from '../../assets/Icons/ModelsDevProviders/gitlab.svg'
import icon__42_google_svg from '../../assets/Icons/ModelsDevProviders/google.svg'
import icon__43_google_vertex_svg from '../../assets/Icons/ModelsDevProviders/google-vertex.svg'
import icon__44_google_vertex_anthropic_svg from '../../assets/Icons/ModelsDevProviders/google-vertex-anthropic.svg'
import icon__45_groq_svg from '../../assets/Icons/ModelsDevProviders/groq.svg'
import icon__46_helicone_svg from '../../assets/Icons/ModelsDevProviders/helicone.svg'
import icon__47_hpc_ai_svg from '../../assets/Icons/ModelsDevProviders/hpc-ai.svg'
import icon__48_huggingface_svg from '../../assets/Icons/ModelsDevProviders/huggingface.svg'
import icon__49_iflowcn_svg from '../../assets/Icons/ModelsDevProviders/iflowcn.svg'
import icon__50_inception_svg from '../../assets/Icons/ModelsDevProviders/inception.svg'
import icon__51_inceptron_svg from '../../assets/Icons/ModelsDevProviders/inceptron.svg'
import icon__52_inference_svg from '../../assets/Icons/ModelsDevProviders/inference.svg'
import icon__53_inferx_svg from '../../assets/Icons/ModelsDevProviders/inferx.svg'
import icon__54_io_net_svg from '../../assets/Icons/ModelsDevProviders/io-net.svg'
import icon__55_jiekou_svg from '../../assets/Icons/ModelsDevProviders/jiekou.svg'
import icon__56_kenari_svg from '../../assets/Icons/ModelsDevProviders/kenari.svg'
import icon__57_kilo_svg from '../../assets/Icons/ModelsDevProviders/kilo.svg'
import icon__58_kimi_for_coding_svg from '../../assets/Icons/ModelsDevProviders/kimi-for-coding.svg'
import icon__59_kuae_cloud_coding_plan_svg from '../../assets/Icons/ModelsDevProviders/kuae-cloud-coding-plan.svg'
import icon__60_lilac_svg from '../../assets/Icons/ModelsDevProviders/lilac.svg'
import icon__61_llama_svg from '../../assets/Icons/ModelsDevProviders/llama.svg'
import icon__62_llmgateway_svg from '../../assets/Icons/ModelsDevProviders/llmgateway.svg'
import icon__63_llmtr_svg from '../../assets/Icons/ModelsDevProviders/llmtr.svg'
import icon__64_longcat_svg from '../../assets/Icons/ModelsDevProviders/longcat.svg'
import icon__65_lucidquery_svg from '../../assets/Icons/ModelsDevProviders/lucidquery.svg'
import icon__66_meganova_svg from '../../assets/Icons/ModelsDevProviders/meganova.svg'
import icon__67_merge_gateway_svg from '../../assets/Icons/ModelsDevProviders/merge-gateway.svg'
import icon__68_meta_svg from '../../assets/Icons/ModelsDevProviders/meta.svg'
import icon__69_minimax_svg from '../../assets/Icons/ModelsDevProviders/minimax.svg'
import icon__70_minimax_cn_svg from '../../assets/Icons/ModelsDevProviders/minimax-cn.svg'
import icon__71_minimax_cn_coding_plan_svg from '../../assets/Icons/ModelsDevProviders/minimax-cn-coding-plan.svg'
import icon__72_minimax_coding_plan_svg from '../../assets/Icons/ModelsDevProviders/minimax-coding-plan.svg'
import icon__73_mistral_svg from '../../assets/Icons/ModelsDevProviders/mistral.svg'
import icon__74_mixlayer_svg from '../../assets/Icons/ModelsDevProviders/mixlayer.svg'
import icon__75_moark_svg from '../../assets/Icons/ModelsDevProviders/moark.svg'
import icon__76_model_oracle_ai_svg from '../../assets/Icons/ModelsDevProviders/model-oracle-ai.svg'
import icon__77_modelscope_svg from '../../assets/Icons/ModelsDevProviders/modelscope.svg'
import icon__78_moonshotai_svg from '../../assets/Icons/ModelsDevProviders/moonshotai.svg'
import icon__79_moonshotai_cn_svg from '../../assets/Icons/ModelsDevProviders/moonshotai-cn.svg'
import icon__80_nano_gpt_svg from '../../assets/Icons/ModelsDevProviders/nano-gpt.svg'
import icon__81_nearai_svg from '../../assets/Icons/ModelsDevProviders/nearai.svg'
import icon__82_nebius_svg from '../../assets/Icons/ModelsDevProviders/nebius.svg'
import icon__83_neon_svg from '../../assets/Icons/ModelsDevProviders/neon.svg'
import icon__84_neuralwatt_svg from '../../assets/Icons/ModelsDevProviders/neuralwatt.svg'
import icon__85_nova_svg from '../../assets/Icons/ModelsDevProviders/nova.svg'
import icon__86_novita_ai_svg from '../../assets/Icons/ModelsDevProviders/novita-ai.svg'
import icon__87_nvidia_svg from '../../assets/Icons/ModelsDevProviders/nvidia.svg'
import icon__88_ollama_cloud_svg from '../../assets/Icons/ModelsDevProviders/ollama-cloud.svg'
import icon__89_openai_svg from '../../assets/Icons/ModelsDevProviders/openai.svg'
import icon__90_opencode_svg from '../../assets/Icons/ModelsDevProviders/opencode.svg'
import icon__91_opencode_go_svg from '../../assets/Icons/ModelsDevProviders/opencode-go.svg'
import icon__92_openrouter_svg from '../../assets/Icons/ModelsDevProviders/openrouter.svg'
import icon__93_orcarouter_svg from '../../assets/Icons/ModelsDevProviders/orcarouter.svg'
import icon__94_ovhcloud_svg from '../../assets/Icons/ModelsDevProviders/ovhcloud.svg'
import icon__95_perplexity_svg from '../../assets/Icons/ModelsDevProviders/perplexity.svg'
import icon__96_perplexity_agent_svg from '../../assets/Icons/ModelsDevProviders/perplexity-agent.svg'
import icon__97_pioneer_svg from '../../assets/Icons/ModelsDevProviders/pioneer.svg'
import icon__98_poe_svg from '../../assets/Icons/ModelsDevProviders/poe.svg'
import icon__99_poolside_svg from '../../assets/Icons/ModelsDevProviders/poolside.svg'
import icon__100_privatemode_ai_svg from '../../assets/Icons/ModelsDevProviders/privatemode-ai.svg'
import icon__101_qihang_ai_svg from '../../assets/Icons/ModelsDevProviders/qihang-ai.svg'
import icon__102_qiniu_ai_svg from '../../assets/Icons/ModelsDevProviders/qiniu-ai.svg'
import icon__103_regolo_ai_svg from '../../assets/Icons/ModelsDevProviders/regolo-ai.svg'
import icon__104_routing_run_svg from '../../assets/Icons/ModelsDevProviders/routing-run.svg'
import icon__105_scaleway_svg from '../../assets/Icons/ModelsDevProviders/scaleway.svg'
import icon__106_siliconflow_svg from '../../assets/Icons/ModelsDevProviders/siliconflow.svg'
import icon__107_siliconflow_cn_svg from '../../assets/Icons/ModelsDevProviders/siliconflow-cn.svg'
import icon__108_snowflake_cortex_svg from '../../assets/Icons/ModelsDevProviders/snowflake-cortex.svg'
import icon__109_stackit_svg from '../../assets/Icons/ModelsDevProviders/stackit.svg'
import icon__110_subconscious_svg from '../../assets/Icons/ModelsDevProviders/subconscious.svg'
import icon__111_submodel_svg from '../../assets/Icons/ModelsDevProviders/submodel.svg'
import icon__112_tencent_coding_plan_svg from '../../assets/Icons/ModelsDevProviders/tencent-coding-plan.svg'
import icon__113_tencent_token_plan_svg from '../../assets/Icons/ModelsDevProviders/tencent-token-plan.svg'
import icon__114_tencent_tokenhub_svg from '../../assets/Icons/ModelsDevProviders/tencent-tokenhub.svg'
import icon__115_the_grid_ai_svg from '../../assets/Icons/ModelsDevProviders/the-grid-ai.svg'
import icon__116_tinfoil_svg from '../../assets/Icons/ModelsDevProviders/tinfoil.svg'
import icon__117_togetherai_svg from '../../assets/Icons/ModelsDevProviders/togetherai.svg'
import icon__118_trustedrouter_svg from '../../assets/Icons/ModelsDevProviders/trustedrouter.svg'
import icon__119_umans_ai_svg from '../../assets/Icons/ModelsDevProviders/umans-ai.svg'
import icon__120_umans_ai_coding_plan_svg from '../../assets/Icons/ModelsDevProviders/umans-ai-coding-plan.svg'
import icon__121_unorouter_svg from '../../assets/Icons/ModelsDevProviders/unorouter.svg'
import icon__122_v0_svg from '../../assets/Icons/ModelsDevProviders/v0.svg'
import icon__123_venice_svg from '../../assets/Icons/ModelsDevProviders/venice.svg'
import icon__124_vercel_svg from '../../assets/Icons/ModelsDevProviders/vercel.svg'
import icon__125_vivgrid_svg from '../../assets/Icons/ModelsDevProviders/vivgrid.svg'
import icon__126_vultr_svg from '../../assets/Icons/ModelsDevProviders/vultr.svg'
import icon__127_wafer_ai_svg from '../../assets/Icons/ModelsDevProviders/wafer.ai.svg'
import icon__128_xai_svg from '../../assets/Icons/ModelsDevProviders/xai.svg'
import icon__129_xiaomi_svg from '../../assets/Icons/ModelsDevProviders/xiaomi.svg'
import icon__130_xiaomi_token_plan_ams_svg from '../../assets/Icons/ModelsDevProviders/xiaomi-token-plan-ams.svg'
import icon__131_xiaomi_token_plan_cn_svg from '../../assets/Icons/ModelsDevProviders/xiaomi-token-plan-cn.svg'
import icon__132_xiaomi_token_plan_sgp_svg from '../../assets/Icons/ModelsDevProviders/xiaomi-token-plan-sgp.svg'
import icon__133_xpersona_svg from '../../assets/Icons/ModelsDevProviders/xpersona.svg'
import icon__134_zai_svg from '../../assets/Icons/ModelsDevProviders/zai.svg'
import icon__135_zai_coding_plan_svg from '../../assets/Icons/ModelsDevProviders/zai-coding-plan.svg'
import icon__136_zeldoc_svg from '../../assets/Icons/ModelsDevProviders/zeldoc.svg'
import icon__137_zenifra_svg from '../../assets/Icons/ModelsDevProviders/zenifra.svg'
import icon__138_zenmux_svg from '../../assets/Icons/ModelsDevProviders/zenmux.svg'
import icon__139_zhipuai_svg from '../../assets/Icons/ModelsDevProviders/zhipuai.svg'
import icon__140_zhipuai_coding_plan_svg from '../../assets/Icons/ModelsDevProviders/zhipuai-coding-plan.svg'
import icon__153_tencent_svg from '../../assets/Icons/ModelsDevProviders/tencent.svg'

const modelsDevProviderIcons = {
  "302ai": icon__0_302ai_svg,
  "abacus": icon__1_abacus_svg,
  "abliteration-ai": icon__2_abliteration_ai_svg,
  "aihubmix": icon__3_aihubmix_svg,
  "alibaba": icon__4_alibaba_svg,
  "alibaba-cn": icon__5_alibaba_cn_svg,
  "alibaba-coding-plan": icon__6_alibaba_coding_plan_svg,
  "alibaba-coding-plan-cn": icon__7_alibaba_coding_plan_cn_svg,
  "alibaba-token-plan": icon__8_alibaba_token_plan_svg,
  "amazon-bedrock": icon__9_amazon_bedrock_svg,
  "aws": icon__9_amazon_bedrock_svg,
  "ambient": icon__10_ambient_svg,
  "anthropic": icon__11_anthropic_svg,
  "anyapi": icon__12_anyapi_svg,
  "atomic-chat": icon__13_atomic_chat_svg,
  "auriko": icon__14_auriko_svg,
  "azure": icon__15_azure_svg,
  "azure-cognitive-services": icon__16_azure_cognitive_services_svg,
  "bailing": icon__17_bailing_svg,
  "baseten": icon__18_baseten_svg,
  "berget": icon__19_berget_svg,
  "cerebras": icon__20_cerebras_svg,
  "claudinio": icon__21_claudinio_svg,
  "cloudferro-sherlock": icon__22_cloudferro_sherlock_svg,
  "cloudflare-ai-gateway": icon__23_cloudflare_ai_gateway_svg,
  "cloudflare-workers-ai": icon__24_cloudflare_workers_ai_svg,
  "cohere": icon__25_cohere_svg,
  "crossmodel": icon__26_crossmodel_svg,
  "deepinfra": icon__27_deepinfra_svg,
  "deepseek": icon__28_deepseek_svg,
  "digitalocean": icon__29_digitalocean_svg,
  "dinference": icon__30_dinference_svg,
  "drun": icon__31_drun_svg,
  "empiriolabs": icon__32_empiriolabs_svg,
  "evroc": icon__33_evroc_svg,
  "fastrouter": icon__34_fastrouter_svg,
  "fireworks-ai": icon__35_fireworks_ai_svg,
  "fireworksai": icon__35_fireworks_ai_svg,
  "freemodel": icon__36_freemodel_svg,
  "friendli": icon__37_friendli_svg,
  "frogbot": icon__38_frogbot_svg,
  "github-copilot": icon__39_github_copilot_svg,
  "github-models": icon__40_github_models_svg,
  "gitlab": icon__41_gitlab_svg,
  "google": icon__42_google_svg,
  "gemini": icon__42_google_svg,
  "google-vertex": icon__43_google_vertex_svg,
  "gcp": icon__43_google_vertex_svg,
  "google-vertex-anthropic": icon__44_google_vertex_anthropic_svg,
  "groq": icon__45_groq_svg,
  "helicone": icon__46_helicone_svg,
  "hpc-ai": icon__47_hpc_ai_svg,
  "huggingface": icon__48_huggingface_svg,
  "iflowcn": icon__49_iflowcn_svg,
  "inception": icon__50_inception_svg,
  "inceptron": icon__51_inceptron_svg,
  "inference": icon__52_inference_svg,
  "inferx": icon__53_inferx_svg,
  "io-net": icon__54_io_net_svg,
  "jiekou": icon__55_jiekou_svg,
  "kenari": icon__56_kenari_svg,
  "kilo": icon__57_kilo_svg,
  "kimi-for-coding": icon__58_kimi_for_coding_svg,
  "kuae-cloud-coding-plan": icon__59_kuae_cloud_coding_plan_svg,
  "lilac": icon__60_lilac_svg,
  "llama": icon__61_llama_svg,
  "llmgateway": icon__62_llmgateway_svg,
  "llmtr": icon__63_llmtr_svg,
  "longcat": icon__64_longcat_svg,
  "lucidquery": icon__65_lucidquery_svg,
  "meganova": icon__66_meganova_svg,
  "merge-gateway": icon__67_merge_gateway_svg,
  "meta": icon__68_meta_svg,
  "minimax": icon__69_minimax_svg,
  "minimax-cn": icon__70_minimax_cn_svg,
  "minimax-cn-coding-plan": icon__71_minimax_cn_coding_plan_svg,
  "minimax-coding-plan": icon__72_minimax_coding_plan_svg,
  "mistral": icon__73_mistral_svg,
  "mixlayer": icon__74_mixlayer_svg,
  "moark": icon__75_moark_svg,
  "model-oracle-ai": icon__76_model_oracle_ai_svg,
  "modelscope": icon__77_modelscope_svg,
  "moonshotai": icon__78_moonshotai_svg,
  "moonshotai-cn": icon__79_moonshotai_cn_svg,
  "nano-gpt": icon__80_nano_gpt_svg,
  "nearai": icon__81_nearai_svg,
  "nebius": icon__82_nebius_svg,
  "neon": icon__83_neon_svg,
  "neuralwatt": icon__84_neuralwatt_svg,
  "nova": icon__85_nova_svg,
  "novita-ai": icon__86_novita_ai_svg,
  "nvidia": icon__87_nvidia_svg,
  "ollama-cloud": icon__88_ollama_cloud_svg,
  "openai": icon__89_openai_svg,
  "opencode": icon__90_opencode_svg,
  "opencode-go": icon__91_opencode_go_svg,
  "openrouter": icon__92_openrouter_svg,
  "orcarouter": icon__93_orcarouter_svg,
  "ovhcloud": icon__94_ovhcloud_svg,
  "perplexity": icon__95_perplexity_svg,
  "perplexity-agent": icon__96_perplexity_agent_svg,
  "pioneer": icon__97_pioneer_svg,
  "poe": icon__98_poe_svg,
  "poolside": icon__99_poolside_svg,
  "privatemode-ai": icon__100_privatemode_ai_svg,
  "qihang-ai": icon__101_qihang_ai_svg,
  "qiniu-ai": icon__102_qiniu_ai_svg,
  "regolo-ai": icon__103_regolo_ai_svg,
  "routing-run": icon__104_routing_run_svg,
  "scaleway": icon__105_scaleway_svg,
  "siliconflow": icon__106_siliconflow_svg,
  "siliconflow-cn": icon__107_siliconflow_cn_svg,
  "snowflake-cortex": icon__108_snowflake_cortex_svg,
  "stackit": icon__109_stackit_svg,
  "subconscious": icon__110_subconscious_svg,
  "submodel": icon__111_submodel_svg,
  "tencent-coding-plan": icon__112_tencent_coding_plan_svg,
  "tencent-token-plan": icon__113_tencent_token_plan_svg,
  "tencent-tokenhub": icon__114_tencent_tokenhub_svg,
  "the-grid-ai": icon__115_the_grid_ai_svg,
  "tinfoil": icon__116_tinfoil_svg,
  "togetherai": icon__117_togetherai_svg,
  "together": icon__117_togetherai_svg,
  "trustedrouter": icon__118_trustedrouter_svg,
  "umans-ai": icon__119_umans_ai_svg,
  "umans-ai-coding-plan": icon__120_umans_ai_coding_plan_svg,
  "unorouter": icon__121_unorouter_svg,
  "v0": icon__122_v0_svg,
  "venice": icon__123_venice_svg,
  "vercel": icon__124_vercel_svg,
  "vivgrid": icon__125_vivgrid_svg,
  "vultr": icon__126_vultr_svg,
  "wafer.ai": icon__127_wafer_ai_svg,
  "xai": icon__128_xai_svg,
  "xiaomi": icon__129_xiaomi_svg,
  "xiaomi-token-plan-ams": icon__130_xiaomi_token_plan_ams_svg,
  "xiaomi-token-plan-cn": icon__131_xiaomi_token_plan_cn_svg,
  "xiaomi-token-plan-sgp": icon__132_xiaomi_token_plan_sgp_svg,
  "xpersona": icon__133_xpersona_svg,
  "zai": icon__134_zai_svg,
  "zai-coding-plan": icon__135_zai_coding_plan_svg,
  "zeldoc": icon__136_zeldoc_svg,
  "zenifra": icon__137_zenifra_svg,
  "zenmux": icon__138_zenmux_svg,
  "zhipuai": icon__139_zhipuai_svg,
  "zhipuai-coding-plan": icon__140_zhipuai_coding_plan_svg,
  "tencent": icon__153_tencent_svg
}

export const getModelsDevProviderIcon = id => modelsDevProviderIcons[String(id || '').toLowerCase()]

export default modelsDevProviderIcons
